var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"in-passWordChange"},[_c('div',{staticClass:"in-changePW flex-center",on:{"click":_vm.logout}},[_c('ec-svg-icon',{attrs:{"icon-class":"icon-tuichu"}}),_vm._v(" "),_c('p',[_vm._v("登出")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-440c2880","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/components/EcHeaderLogout.vue
// module id = null
// module chunks = 